function stripMarkdownCodeFences(text: string): string {
  const trimmed = text.trim();
  const fenced = trimmed.match(/^```(?:markdown|md)?\s*([\s\S]*?)\s*```$/i);
  if (fenced) {
    return fenced[1].trim();
  }
  if (trimmed.startsWith("```")) {
    return trimmed
      .replace(/^```(?:markdown|md)?\s*/i, "")
      .replace(/\s*```$/, "")
      .trim();
  }
  return trimmed;
}

function normalizeHeadingText(value: string): string {
  return value
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^\w\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** Remove a leading markdown heading when it duplicates the section card title. */
export function stripDuplicateSectionHeading(
  content: string,
  sectionLabel: string,
): string {
  const lines = content.split("\n");
  if (lines.length === 0) {
    return content;
  }

  const firstLine = lines[0].trim();
  const headingMatch = firstLine.match(/^#{1,6}\s+(.+)$/);
  if (!headingMatch) {
    return content;
  }

  if (normalizeHeadingText(headingMatch[1]) === normalizeHeadingText(sectionLabel)) {
    return lines.slice(1).join("\n").trim();
  }

  return content;
}

/** Normalize LLM markdown so ReactMarkdown renders paragraphs, lists, and headings cleanly. */
export function normalizeBusinessPlanSectionMarkdown(
  content: string,
  options?: { sectionLabel?: string },
): string {
  if (!content) {
    return "";
  }

  let text = content.trim();

  // Some model responses store literal "\n" instead of real line breaks.
  if (text.includes("\\n") || text.includes("\\t")) {
    text = text
      .replace(/\\n/g, "\n")
      .replace(/\\t/g, "\t")
      .replace(/\\r/g, "")
      .replace(/\\"/g, '"');
  }

  text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  text = stripMarkdownCodeFences(text);

  if (options?.sectionLabel) {
    text = stripDuplicateSectionHeading(text, options.sectionLabel);
  }

  text = text.replace(/\n{3,}/g, "\n\n");

  return text.trim();
}
